export default __webpack_public_path__ + "assets/img/ict-upload-ppt.704cdfc623628e98d5b80307b2a3d2b4.svg";